import { clsx } from 'clsx';
import { Heart3 } from '@hungryroot/ui-kit';
import { useFavoriteHeart } from './useFavoriteHeart';
import styles from './FavoriteHeartIcon.module.css';

/**
 * `sticker` — a white rim and a drop shadow, so the heart keeps its shape over
 * food photography. Every surface that sits a heart on a card image wants this,
 * which is why it is the default.
 *
 * `plain` — the bare shape, for a heart on a flat surface, where the rim has
 * nothing to separate the heart from and reads as a ring around it.
 */
type FavoriteHeartIconVariant = 'sticker' | 'plain';

interface FavoriteHeartIconProps {
  isFavorited: boolean;
  className?: string;
  variant?: FavoriteHeartIconVariant;
}

export function FavoriteHeartIcon(props: FavoriteHeartIconProps) {
  const { isFavorited, className, variant = 'sticker' } = props;
  const { isPopping, onAnimationEnd } = useFavoriteHeart({ isFavorited });

  return (
    <span
      className={clsx(styles.heart, className, { [styles.pop]: isPopping })}
      onAnimationEnd={onAnimationEnd}
      data-favorited={isFavorited}
    >
      <Heart3
        className={clsx({
          [styles.sticker]: variant === 'sticker',
          [styles.plain]: variant === 'plain',
          [styles.favorited]: isFavorited,
          [styles.unfavorited]: !isFavorited,
        })}
      />
    </span>
  );
}
